__webpack_require__.p = "https://assets-qa.socrative.com/4.12.2477/js/";